function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./cluster-selection-item-component.scss";
import PictureComponent from "/components/core/picture/picture-component";
class ClusterSelectionItemComponent extends PureComponent {
    render() {
        const { title, imgSrc, color, isSelected, imgDimensions } = this.props;
        const componentStyle = {
            borderColor: color
        };
        return /*#__PURE__*/ _jsxs("div", {
            style: componentStyle,
            onClick: this.onClick,
            className: `jsx-${componentStyles.__hash}` + " " + (classnames("cluster-selection-item-component", {
                selected: isSelected
            }) || ""),
            children: [
                /*#__PURE__*/ _jsx(PictureComponent, {
                    pictureClass: "cluster-selection-item-image",
                    src: imgSrc,
                    alt: title,
                    specificImageStyle: imgDimensions
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "title",
                    children: title
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onClick", ()=>{
            const { id, onClick } = this.props;
            onClick(id);
        });
    }
}
export { ClusterSelectionItemComponent as default };
ClusterSelectionItemComponent.defaultProps = {
    imgDimensions: {
        width: 30
    }
};
